import React, { useEffect, useState } from "react";
import JumboListNoDataPlaceHolder from "@jumbo/components/JumboList/components/JumboListNoDataPlaceHolder";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import {
  Card,
  IconButton,
  Tooltip,
  Typography,
  Stack,
  Box,
  Pagination,
  FormControlLabel,
  Switch,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import CustomerItem from "./ClientItem";
import { useJumboDialog } from "@jumbo/components/JumboDialog/hooks/useJumboDialog";
import JumboSearch from "@jumbo/components/JumboSearch";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { getClients } from "app/services/api/management";
import { useNavigate } from "react-router-dom";

const ITEM_PER_PAGE = 10;

const ClientList = () => {
  const { getAuthUser, setAuthToken } = useJumboAuth();
  const { customerId } = getAuthUser() || {};
  const { t } = useTranslation();
  const { showDialog, hideDialog } = useJumboDialog();
  const [searchName, setSearchName] = useState();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [onlyActive, setOnlyActive] = useState(true);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const loadClients = async () => {
    setLoading(true);
    await getClients().then((clients) => {
      if (searchName) {
        if (onlyActive) {
          const filteredClients = clients.filter(
            (client) =>
              (client.companyName
                .toLowerCase()
                .includes(searchName.toLowerCase()) ||
                client.email.toLowerCase().includes(searchName.toLowerCase()) ||
                client.phone
                  .toLowerCase()
                  .includes(searchName.toLowerCase())) &&
              client.active === onlyActive
          );
          setClients(filteredClients || []);
        } else {
          const filteredClients = clients.filter(
            (client) =>
              client.companyName
                .toLowerCase()
                .includes(
                  searchName.toLowerCase() ||
                    client.email
                      .toLowerCase()
                      .includes(searchName.toLowerCase()) ||
                    client.phone
                      .toLowerCase()
                      .includes(searchName.toLowerCase())
                ) && client.active === onlyActive
          );
          setClients(filteredClients || []);
        }
      } else {
        if (onlyActive) {
          const filteredClients = clients.filter(
            (client) => client.active === onlyActive
          );
          setClients(filteredClients || []);
        } else {
          setClients(clients || []);
        }
      }
    });
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    searchName !== undefined && loadClients();
  }, [searchName, onlyActive]);

  return (
    <React.Fragment>
      <Typography variant={"h2"} mb={3}>
        {t("pages.dsokDetails.clients.title")}
      </Typography>
      <Stack
        direction="row"
        display="flex"
        alignItems="center"
        justifyContent={"space-between"}
        mb={2}
        spacing={1}
      >
        <Box width="50%" display="flex" flexDirection="row" gap={1}>
          <Card sx={{ mb: 0, width: "100%" }}>
            <JumboSearch
              page="customers"
              onChange={setSearchName}
              sx={{
                width: "100%",
              }}
              placeholder={t("pages.presentation.searchPresentation")}
            />
          </Card>
          <Tooltip title={t("pages.customer.addCustomer")}>
            <IconButton onClick={() => navigate("/customer/dsok/clients/new")}>
              <AddBoxIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <Box display="flex" alignItems="left" mb={2} ml={2}>
          <FormControlLabel
            labelPlacement="start"
            control={
              <Switch
                checked={onlyActive}
                onChange={(event) => setOnlyActive(event.target.checked)}
                name="onlyActive"
                color="primary"
              />
            }
            label={t("pages.dsokCustomers.onlyActive")}
            sx={{
              ml: 2,
              fontSize: "12px",
            }}
          />
        </Box>
        <Pagination
          count={Math.ceil(clients?.length / ITEM_PER_PAGE)}
          color="primary"
          page={page}
          onChange={(_, val) => setPage(val)}
        />
      </Stack>
      {loading ? (
        <CircularProgress sx={{ m: "5px 50%" }} />
      ) : (
        <>
          {clients?.length ? (
            clients.map((client, index) =>
              index + 1 > ITEM_PER_PAGE * (page - 1) &&
              index + 1 <= ITEM_PER_PAGE * page ? (
                <CustomerItem key={index} item={client} disabled={loading} />
              ) : null
            )
          ) : (
            <JumboListNoDataPlaceHolder />
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default ClientList;
